module.exports = __webpack_public_path__ + "media/images/icons/download-631e0dfcab8625e805a3f956a86339f8.svg";